import Orientation from 'react-native-orientation';
import {
    View, Text, StyleSheet, ScrollView, TouchableOpacity,
    TextInput, StatusBar, FlatList, Alert, PermissionsAndroid,
    ToastAndroid, Platform, Dimensions, ActivityIndicator, BackHandler
} from 'react-native';
import React, { Component } from 'react';
import { Image } from 'react-native';
import Colors from './Colors'
import { RNCamera } from 'react-native-camera';
import Icon from 'react-native-vector-icons/FontAwesome';
import moment from 'react-moment'
import Geolocation from '@react-native-community/geolocation';
import {
    PAN_CARD, POLICE_FIR, EXTERNAL_DAMAGE, INTERNAL_DAMAGE, RC_BOOK, AADHAR_CARD, CNG, DRIVING_LICENSE,
    VIDEO_TITLE, SELFI_IMAGE, ODOMETER, VIDEO_URL, PRIVATE_CAR_20103, PRIVATE_CAR_20102, PRIVATE_CAR_20101,
    BIKE_20202, BIKE_20201, CUMMERCIAL_20302, CUMMERCIAL_20301, isPI
} from './Constants'
import DeviceInfo from 'react-native-device-info';
// const IMEI = require('react-native-imei');
import VideoPlayer from 'react-native-video-player'
import { INSTRUCTIONS_URL, SELFSURVEYSERVICE_DOCUMENT_URL, AGENT_DATA } from '../Api/ApiUrls'
const initial = Orientation.getInitialOrientation();
let SCREEN_WIDTH;
let SCREEN_HEIGHT;
if (initial === 'PORTRAIT') {
    SCREEN_HEIGHT = Math.round(Dimensions.get('window').width - 40)
    SCREEN_WIDTH = Math.round(Dimensions.get('window').height)
} else {
    SCREEN_HEIGHT = Math.round(Dimensions.get('window').height)
    SCREEN_WIDTH = Math.round(Dimensions.get('window').width)
}

export default class DocumentCollection extends Component {
    constructor(props) {
        super(props);
        this.state = ({
            isDisplayQuoteInstruction: true,
            isWithQuote: true,
            isWithOutQuote: false,
            isDisplayInstruction: false,
            torchon: '',
            isDisplayCameraPreview: false,
            isDisplayCamera: false,
            localPath: '',
            flashState: true,//for flash
            dateAndTime: '',//date and time
            currentLongitude: 'unknown',//Initial Longitude
            currentLatitude: 'unknown',//Initial Latitude
            isDisplayVideoRecorder: false,
            instructionData: '',
            fullDataSource: '',
            assets: '',
            headerShown: false,
            count: 0,
            dataSource: '',
            cameraState: '',
            buttonText: '',
            skipdata: '',
            isBackButtonPressed: false,
            isSkipButtonPressed: false,
            extention: '',
            screenShotPath: '',
            isDisplayUploadDocument: false,
            upLoadIamgeDataSource: [],
            documentUploadPercentage: 0,
            odometerReading: '',
            ANDROID_ID: '',
            CurrentDate: '',
            showError: false,
            isLoading: true,
            registrationNumber: '',
            isSelected: false,
            isFocused: false,
            staincil: '',
            activityTypeId: props.screenProps.activityTypeId
        })

    }

    componentDidMount() {
        if (initial === 'PORTRAIT')
            Orientation.lockToLandscapeLeft()//make landscape

        PermissionsAndroid.requestMultiple(
            [PermissionsAndroid.PERMISSIONS.CAMERA,
            PermissionsAndroid.PERMISSIONS.READ_CONTACTS,
            PermissionsAndroid.PERMISSIONS.ACCESS_FINE_LOCATION,
            PermissionsAndroid.PERMISSIONS.ACCESS_COARSE_LOCATION,
            PermissionsAndroid.PERMISSIONS.READ_EXTERNAL_STORAGE,
            PermissionsAndroid.PERMISSIONS.READ_PHONE_STATE,
            PermissionsAndroid.PERMISSIONS.WRITE_EXTERNAL_STORAGE,]
        ).then((result) => {
            if (result['android.permission.ACCESS_COARSE_LOCATION']
                && result['android.permission.CAMERA']
                && result['android.permission.READ_CONTACTS']
                && result['android.permission.ACCESS_FINE_LOCATION']
                && result['android.permission.READ_PHONE_STATE']
                && result['android.permission.READ_EXTERNAL_STORAGE']
                && result['android.permission.WRITE_EXTERNAL_STORAGE'] === 'granted') {
                this.setState({
                    permissionsGranted: true
                });
                // DeviceInfo.getAndroidId().then(androidId => {
                //     this.setState({ ANDROID_ID: androidId })
                //   });
                console.log("Current Date :- " + Date.now())
                this.setState({ CurrentDate: Date.now() })

                DeviceInfo.getApiLevel().then(apiLevel => {

                    this.setState({ API_LEVEL: apiLevel })

                });

                if (this.state.API_LEVEL > 28) {
                    DeviceInfo.getAndroidId().then(androidId => {
                        this.setState({ ANDROID_ID: androidId })

                    });
                } else {
                    // IMEI.getImei().then(imeiList => {
                    //     console.log("sssssssssssssssssssssssss" + imeiList)
                    // });
                }
                DeviceInfo.getDeviceName().then(deviceName => {
                    this.setState({ DEVICE_NAME: deviceName })
                });

                DeviceInfo.getIpAddress().then(ip => {
                    this.setState({ IP: ip })
                });
                DeviceInfo.getMacAddress().then(mac => {
                    this.setState({
                        MAC: mac,
                    })
                });



                Orientation.lockToLandscapeLeft()
                Orientation.addOrientationListener(this._orientationDidChange);

                // this locks the view to Landscape Mode
                // Orientation.lockToLandscape();

                // this unlocks any previous locks to all Orientations
                // Orientation.unlockAllOrientations();
                console.log("SH :- " + SCREEN_HEIGHT)
                console.log("SW :- " + SCREEN_WIDTH)

                this.callLocation() //to get lat l
                this.callInstructionApi()

            } else if (result['android.permission.ACCESS_COARSE_LOCATION']
                || result['android.permission.CAMERA']
                || result['android.permission.READ_CONTACTS']
                || result['android.permission.ACCESS_FINE_LOCATION']
                || result['android.permission.READ_EXTERNAL_STORAGE']
                || result['android.permission.READ_PHONE_STATE']
                || result['android.permission.WRITE_EXTERNAL_STORAGE'] === 'never_ask_again') {
            }
        });
        this.handleBackButton()
    }
    handleBackButton() {
        if (Platform.OS === 'android') {
            this.backHandler = BackHandler.addEventListener('hardwareBackPress', () => {

                return true;
            });
        }
    }
    startCollectingSensorData() {
        if (isPI(this.state.activityTypeId)) {

        }
    }
    componentWillUnmount() {
        Orientation.getOrientation((err, orientation) => {
            console.log(`Current Device Orientation: ${orientation}`);//display currrent location state

        });


        // Remember to remove listener
        Orientation.removeOrientationListener(this._orientationDidChange);
        Geolocation.clearWatch(this.watchID);//For GeoLocation
        Orientation.lockToPortrait()
        if (Platform.OS === 'android') {
            this.backHandler.remove();
        }
    }
    _orientationDidChange = (orientation) => {
        if (orientation === 'LANDSCAPE') {
            // do something with landscape layoutr
            SCREEN_HEIGHT = Math.round(Dimensions.get('window').height)
            SCREEN_WIDTH = Math.round(Dimensions.get('window').width)

        } else {
            // do something with portrait layout   
            SCREEN_HEIGHT = Math.round(Dimensions.get('window').width)
            SCREEN_WIDTH = Math.round(Dimensions.get('window').height)
        }
    }
    callLocation() {
        //alert("callLocation Called");
        console.log("loccation!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!")
        Geolocation.getCurrentPosition(
            //Will give you the current location
            (position) => {
                const longitude = JSON.stringify(position.coords.longitude);
                //getting the Longitude from the location json
                const latitude = JSON.stringify(position.coords.latitude);
                //getting the Latitude from the location json
                this.setState({ currentLongitude: longitude });
                //Setting state Longitude to re re-render the Longitude Text
                this.setState({ currentLatitude: latitude });
                //Setting state Latitude to re re-render the Longitude Text
            },
            (error) => {

            },
            { enableHighAccuracy: true, timeout: 20000, maximumAge: 1000 }
        );
        this.watchID = Geolocation.watchPosition((position) => {
            //Will give you the location on location change
            console.log(position);
            const longitude = JSON.stringify(position.coords.longitude);
            //getting the Longitude from the location json
            const latitude = JSON.stringify(position.coords.latitude);
            //getting the Latitude from the location json
            this.setState({ currentLongitude: longitude });
            //Setting state Longitude to re re-render the Longitude Text
            this.setState({ currentLatitude: latitude });
            //Setting state Latitude to re re-render the Longitude Text
        });
    }
    //instruction API
    async callInstructionApi() {
        let vehicleTypeId = 5
        const instruction_url = INSTRUCTIONS_URL + vehicleTypeId + "?isWebRequest=0"
        let resp = await fetch(instruction_url)
        let resJson = await resp.json()
        console.log("INSTRUCTIONS_URL \n\n\n" + resJson.TSurveySteps[0])

        this.setState({ instructionData: resJson.TSurveySteps })
        // console.log(resJson.activityTypeId)
        if (resJson.activityTypeId == 5) {                                     //WE HAVE TO CHANGE 5 TO 12
            this.renderDataToScreen()
        }

    }
    //DATA on screen
    renderDataToScreen() {
        //condition check for the Front camera or Back camera
        if (this.state.count <= this.state.instructionData.length - 1 && this.state.count >= 0) {
            // if (this.state.count <= 2 && this.state.count >= 0) {

            console.log("COUNT: " + this.state.count)
            console.log('SELFI \n\n\n\n\n :::::::::      ', this.state.instructionData[this.state.count].stepTitle);
            console.log('SELFI \n\n\n\n\n :::::::::      ', SELFI_IMAGE);

            if (this.state.instructionData[this.state.count].stepTitle == SELFI_IMAGE) {
                this.setState({
                    cameraState: RNCamera.Constants.Type.front,
                    buttonText: 'Capture Images', extention: '.jpg',
                    skipdata: this.state.instructionData[this.state.count].stepTitle,
                    productImage: this.state.instructionData[this.state.count].imageName,
                    stepTitle: this.state.instructionData[this.state.count].stepTitle
                })
            } else {
                this.setState({
                    cameraState: RNCamera.Constants.Type.back,
                    buttonText: 'Capture Images',
                    skipdata: this.state.instructionData[this.state.count].stepTitle,
                    extention: '.jpg',
                    rcbFront: this.state.instructionData[this.state.count].imageName,
                    productImage: this.state.instructionData[this.state.count].imageName,
                    stepTitle: this.state.instructionData[this.state.count].stepTitle
                })
            }

            if (this.state.instructionData[this.state.count].stepTitle == VIDEO_TITLE) {
                this.setState({
                    assets: "https://d2h44aw7l5xdvz.cloudfront.net/videos/self-inspection-for-car.mp4",
                    isDisplayVideoRecorder: true,
                    isDisplayCameraPreview: false,
                    isDisplayCamera: false,
                    buttonText: 'Capture Video',
                    extention: '.mp4',
                    skipdata: this.state.instructionData[this.state.count].stepTitle,
                    productImage: this.state.instructionData[this.state.count].imageName,
                    stepTitle: this.state.instructionData[this.state.count].stepTitle

                })
            }
            this.setState({
                assets: this.state.instructionData[this.state.count].stepAssests,//Image Url
                header: this.state.instructionData[this.state.count].stepTitle,//Header for screen
                subheader: this.state.instructionData[this.state.count].description,//subheader
                dataSource: this.state.instructionData[this.state.count].TSurveyInstructions,//data to flatList
            })
        }
    }
    //Image or video
    imageOrVideo() {

        if (this.state.assets == VIDEO_URL && this.state.isDisplayVideoRecorder == true) {
            return (
                <VideoPlayer
                    video={{ uri: "https://d2h44aw7l5xdvz.cloudfront.net/videos/self-inspection-for-car.mp4" }}
                    videoHeight={SCREEN_HEIGHT}
                    videoWidth={SCREEN_WIDTH}
                    pauseOnPress={true}
                    autoplay={true}
                    disableSeek={true}
                    style={styles.productImageStyle}>
                </VideoPlayer>
            )

        } else {
            if (this.state.assets)
                return (
                    <Image
                        source={{ uri: this.state.assets }}
                        style={styles.productImageStyle}
                        resizeMethod='auto'
                        resizeMode='contain'
                    />
                )
            else
                return null
        }
    }

    //FlatList
    flatListOrNot(showError) {
        if (this.state.skipdata !== ODOMETER) {
            return (
                <View style={styles.infoScrollView}>
                    {this.state.dataSource !== undefined && this.state.dataSource.length > 0 && <FlatList
                        ref={ref => this.flatList = ref}
                        data={this.state.dataSource}
                        renderItem={this.renderItem}
                        keyExtractor={item => item.surveyInstructionsId}
                        style={{ fontFamily: 'Muli-Regular', }}
                    />}
                </View>
            )
        } else {
            return (
                <View>
                    <View style={styles.infoScrollViewWithTextInput}>
                        {this.state.dataSource !== undefined && this.state.dataSource.length > 0 && <FlatList
                            ref={ref => this.flatList = ref}
                            data={this.state.dataSource}
                            renderItem={this.renderItem}
                            ListHeaderComponent={this.renderListHeader}
                            ListFooterComponent={this.renderListFotter(showError)}
                        />}
                    </View>
                </View>
            )
        }
    }

    //FlatList component
    renderListHeader = () => {
        return (
            <View></View>
        )
    }

    //FlatList component
    renderListFotter = (showError) => {
        return (
            <View>
                <Text style={styles.odometerText}>Odometer Reading:</Text>
                {this.showErrorText(showError)}
                <TextInput
                    style={styles.odometerInputText}
                    keyboardType='numeric'
                    onChangeText={odometerReading => this.setState({ odometerReading })}
                />
            </View>
        )
    }

    //FlatListcomponent
    renderItem = ({ item }) => (
        <Text key={item.surveyInstructionsId} id={item.surveyInstructionsId} style={styles.instructionText}>{'\u2B24'} {item.instructionData}</Text>
    )

    //For error
    showErrorText(showError) {
        if (showError) {
            if (this.flatList)
                this.flatList.scrollToEnd()
            return (
                <Text style={{ color: 'red', marginLeft: 4, fontFamily: 'Muli-Regular' }}>   Enter Odometer Reading</Text>
            )
        } else
            return null

    }


    //For the Button and change the text
    captureButton() {
        //condition for Skip Documents
        if (this.state.skipdata == PAN_CARD || this.state.skipdata == AADHAR_CARD || this.state.skipdata == CNG ||
            this.state.skipdata == POLICE_FIR || this.state.skipdata == EXTERNAL_DAMAGE || this.state.skipdata == INTERNAL_DAMAGE ||
            this.state.skipdata == DRIVING_LICENSE) {
            return (
                <View style={{ flex: 1, flexDirection: 'row' }}>
                    <View style={{ flex: 0.45 }}>
                        <TouchableOpacity onPress={() => this.validate()}>
                            <View style={styles.captureImageButtonView}>
                                <Text style={styles.captureImageButtonText}>Capture</Text>
                            </View>
                        </TouchableOpacity>
                    </View>
                    <View style={{ flex: 0.1 }}></View>
                    <View style={{ flex: 0.45 }}>
                        <TouchableOpacity onPress={() => [this.setState({ isSkipButtonPressed: true }), this.increseCount()]}>
                            <View style={styles.captureImageButtonView}>
                                <Text style={styles.captureImageButtonText}>Skip</Text>
                            </View>
                        </TouchableOpacity>
                    </View>
                </View>
            )
        } else if (this.state.rcbFront == 'RCB2') {
            return (
                <View style={{ flex: 1, flexDirection: 'row' }}>
                    <View style={{ flex: 0.45 }}>
                        <TouchableOpacity onPress={() => [this.validate()]}>
                            <View style={styles.captureImageButtonView}>
                                <Text style={{
                                    fontSize: 14,
                                    fontFamily: 'Muli-Black',
                                    alignSelf: 'center'
                                }}>Capture More</Text>
                            </View>
                        </TouchableOpacity>
                    </View>
                    <View style={{ flex: 0.1 }}></View>
                    <View style={{ flex: 0.45 }}>
                        <TouchableOpacity onPress={() => [this.setState({ isSkipButtonPressed: true }), this.increseCount()]}>
                            <View style={styles.captureImageButtonView}>
                                <Text style={styles.captureImageButtonText}>Skip</Text>
                            </View>
                        </TouchableOpacity>
                    </View>
                </View>
            )
        } else if (this.state.assets == VIDEO_URL) {
            return (
                <TouchableOpacity onPress={() => [this.props.navigation.navigate("VideoRecorder", {
                    staincil: this.state.instructionData[this.state.count].stepStencilAssests,
                    count: this.state.count,
                    productImage: this.state.instructionData[this.state.count].imageName,
                    stepTitle: this.state.stepTitle,
                    extention: this.state.extention,
                    instructionData: this.state.instructionData,

                }), this.setState({ count: this.state.count + 1 }),
                setTimeout(() => {
                    this.renderDataToScreen()
                }, 200)]}>
                    <View style={styles.captureImageButtonView}>
                        <Text style={styles.captureImageButtonText}>Capture Video</Text>
                    </View>
                </TouchableOpacity>
            )
        } else {
            return (
                <TouchableOpacity onPress={() => [this.validate()]}>
                    <View style={styles.captureImageButtonView}>
                        <Text style={styles.captureImageButtonText}>{this.state.buttonText}</Text>
                    </View>
                </TouchableOpacity>
            )
        }
    }

    //for validation logic
    validate() {
        if (this.state.skipdata == ODOMETER) {
            if (this.state.odometerReading != '') {
                this.props.navigation.navigate("Camera", {
                    staincil: this.state.instructionData[this.state.count].stepStencilAssests,
                    count: this.state.count,
                    instructionData: this.state.instructionData,
                    productImage: this.state.instructionData[this.state.count].imageName,
                    stepTitle: this.state.stepTitle,
                    extention: this.state.extention,
                    cameraState: this.state.cameraState

                })
                this.setState({ count: this.state.count + 1, showError: false })
                setTimeout(() => {
                    this.renderDataToScreen()
                }, 200)
            } else {
                this.setState({ showError: true })
            }
        } else {
            this.props.navigation.navigate("Camera", {
                staincil: this.state.instructionData[this.state.count].stepStencilAssests,
                count: this.state.count,
                instructionData: this.state.instructionData,
                productImage: this.state.instructionData[this.state.count].imageName,
                stepTitle: this.state.stepTitle,
                extention: this.state.extention,
                cameraState: this.state.cameraState
            })
            this.setState({ count: this.state.count + 1 })
            setTimeout(() => {
                this.renderDataToScreen()
            }, 200)
        }

        // if (this.state.registrationNumber.length > 0 && this.state.isSelected == true && this.state.isDisplayInstruction == false) {
        //     this.setState({ isDisplayInstruction: true, isWithOutQuote: false })
        // }
    }
    //For go back 
    reduceCount() {
        if (this.state.count >= 1) {
            this.setState({
                count: this.state.count - 1
            })
        }
        if (this.state.count == 0) {
            this.props.navigation.navigate("WithOutQuote")
        }
        setInterval(() => {
            if (this.state.isBackButtonPressed == true) {
                this.renderDataToScreen()
            }
            this.setState({ isBackButtonPressed: false })
        }, 100);

    }
    //for go ahead
    increseCount() {

        if (this.state.count <= this.state.instructionData.length) {
            this.setState({
                count: this.state.count + 1
            })
        }
        setInterval(() => {
            if (this.state.isSkipButtonPressed == true) {
                this.renderDataToScreen()
            }
            this.setState({ isSkipButtonPressed: false })
        }, 100);
    }

    render() {
        //   For Landsccape
        Orientation.lockToLandscapeLeft()

        SCREEN_HEIGHT = Math.round(Dimensions.get('window').height)
        SCREEN_WIDTH = Math.round(Dimensions.get('window').width)
        return (
            <View style={styles.main}>
                <StatusBar
                    hidden={true}
                />
                <View style={{ flex: 1, flexDirection: 'row' }}>
                    {/* product Images */}
                    <View style={styles.productImageView}>
                        <View style={{ flex: 1 }}>
                            <View style={{ flex: 1, flexDirection: 'column' }}>
                                <View style={{ flex: 0.2, flexDirection: 'column' }}>
                                    <TouchableOpacity onPress={() => [this.setState({ isBackButtonPressed: true }), this.reduceCount()]}>
                                        <View style={styles.backButtonImageView}>
                                            <Icon
                                                name="arrow-left"
                                                size={25}
                                                style={{ marginLeft: 16 }}
                                            />
                                        </View>
                                    </TouchableOpacity>
                                </View>
                                <View style={{ flex: 0.8, flexDirection: 'column', justifyContent: 'center' }}>
                                    <View>
                                        {this.imageOrVideo()}
                                    </View>
                                </View>
                            </View>
                        </View>
                    </View>
                    {/* blankView */}
                    <View style={styles.blankView}>
                        <View style={styles.headerView}>
                        </View>
                    </View>
                    {/* product info view */}
                    <View style={styles.productInfoView}>
                        <View style={{ flex: 1, flexDirection: 'column' }}>
                            {/* header */}
                            <View style={{ flex: 0.2, alignItems: "center", backgroundColor: '#F5F5F5', }}>
                                <View style={[styles.headerView, { flex: 1, flexDirection: 'column' }]}>
                                    <Text style={[styles.headerText, { justifyContent: 'flex-end', marginTop: 8 }]}>
                                        {this.state.header}
                                    </Text>
                                </View>
                            </View>
                            {/*Sub header */}
                            <View style={[styles.subHeaderTextView, { flex: 0.2 }]}>
                                <Text style={styles.subHeaderText}>
                                    {this.state.subheader}
                                </Text>
                            </View>
                            {/* items */}
                            <View style={[styles.subHeaderTextView, { flex: 0.7 }]}>
                                {this.flatListOrNot(this.state.showError)}
                            </View>
                        </View>
                        <View style={[styles.subHeaderTextView, { flex: 0.2, paddingLeft: 15, paddingRight: 15 }]}>
                            {this.captureButton()}
                        </View>
                    </View>
                </View>
            </View >
        )
    }

}


const styles = StyleSheet.create({
    main: {
        flex: 1,
        // flexDirection: 'row',
        backgroundColor: '#FFFFFF'
    },
    productImageView: {
        flex: 0.475,
    },
    blankView: {
        flex: 0.05,
    },
    productInfoView: {
        flex: 0.475,
    },
    headerView: {
        backgroundColor: '#F5F5F5',
        height: 60,
        justifyContent: 'center',
    },
    headerText: {
        marginLeft: 16,
        fontSize: 16,
        fontFamily: 'Muli-Black',
        marginRight: 16
    },
    documentProcessHeader: {
        marginLeft: 16,
        fontSize: 26,
        fontFamily: 'Muli-Black',
        marginRight: 16,
        justifyContent: 'center'
    },
    documentProcessView: {
        width: SCREEN_WIDTH,
        height: 60,
        justifyContent: 'center',
        backgroundColor: '#F5F5F5'
    },
    productImageStyle: {
        marginTop: 8,
        marginLeft: 16,
        marginBottom: 40,
        height: SCREEN_HEIGHT - 70,

    },
    backButtonImageStyle: {
        marginLeft: 32,
        height: 30,
        width: 40,
        backgroundColor: 'red'
    },
    subHeaderText: {
        fontFamily: 'Muli-Regular',
        fontSize: 16,
        marginLeft: 16,
        marginRight: 16

    },
    instructionText: {
        fontFamily: 'Muli-Regular',
        fontSize: 16,
        marginLeft: 16,
        marginBottom: 20,
        marginRight: 16

    },
    captureImageButtonView: {
        height: 48,
        borderRadius: 4,
        backgroundColor: Colors.digitYellow,
        flexDirection: 'row',
        justifyContent: 'center',
    },
    captureImageButtonText: {
        fontSize: 16,
        fontFamily: 'Muli-Black',
        alignSelf: 'center'
    },
    container: {
        flex: 1,
        // flexDirection: 'row',
        // backgroundColor: 'black',
    },
    preview: {
        flex: 1,
        justifyContent: 'flex-end',
        alignItems: 'center',
    },
    capture: {
        flex: 0,
        backgroundColor: '#fff',
        borderRadius: 5,
        padding: 15,
        paddingHorizontal: 20,
        alignSelf: 'flex-end',
        margin: 20,
        position: 'absolute'
    },
    flash: {
        flex: 0,
        backgroundColor: '#fff',
        borderRadius: 5,
        padding: 15,
        paddingHorizontal: 20,
        alignSelf: 'flex-end',
        margin: 20,
        position: 'absolute'
    },
    previewImageStyle: {
        width: SCREEN_WIDTH,
        height: SCREEN_HEIGHT,
        resizeMode: 'contain'
    },
    dateAndTimeText: {
        position: 'absolute',
        fontSize: 20,
        color: Colors.digitYellow,
        left: 1,
        bottom: 1
    },
    previewImageIconMainView: {
        flex: 0.05,
        backgroundColor: 'black'
    },
    tickMarkImageView: {
        flex: 0.6,
        justifyContent: 'flex-end'
    },
    tickMarkImageStyle: {
        width: 30,
        height: 30,
        backgroundColor: 'white',
        alignSelf: 'center',
        marginBottom: 20
    },
    crossImageView: {
        flex: 0.4,
        justifyContent: 'flex-end',
        marginBottom: 20
    },
    crossImageStyle: {
        width: 30,
        height: 30,
        backgroundColor: 'white',
        alignSelf: 'center',
    },
    cameraIconView: {
        flexDirection: 'row',
        justifyContent: 'center',
        width: SCREEN_WIDTH,
        position: 'absolute'
    },
    infoScrollView: {
        marginTop: 10,
        // height: SCREEN_HEIGHT - 220
    },
    subHeaderTextView: {
        marginTop: 8
    },
    backButtonImageView: {
        backgroundColor: '#F5F5F5',
        height: 60,
        justifyContent: 'center',
    },
    latLongText: {
        position: 'absolute',
        fontSize: 20,
        color: Colors.digitYellow,
        left: 1,
    },
    digitEdgeText: {
        position: 'absolute',
        fontSize: 20,
        color: Colors.digitYellow,
        right: 1,
    },
    odometerText: {
        fontSize: 16,
        fontFamily: 'Muli-Black',
        marginLeft: 16,
    },
    odometerInputText: {
        fontSize: 16,
        fontFamily: 'Muli-Black',
        borderRadius: 4,
        borderColor: Colors.digitYellow,
        borderWidth: 1,
        marginTop: 5,
        marginRight: 16,
        marginBottom: 5
    },
    infoScrollViewWithTextInput: {
        // height: SCREEN_HEIGHT - 270
    },
    // productImageView: {
    //     flexDirection: 'row',
    //     justifyContent: 'center'
    // },
    // productImage: {
    //     width: 50,
    //     height: 50,
    //     marginTop: 16,
    //     flexDirection: 'row',
    //     justifyContent: 'space-around',
    //     marginLeft: 16,
    //     marginRight: 16
    // },
});